import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { differenceBy } from 'lodash/fp';

// Effects
import usePrevious from '../../../../utils/react/usePrevious';

// Component
import Breadcrumb from '../Breadcrumb';

import breadcrumbTruncateUtilDropTarget from './breadcrumbTruncateUtilDropTarget';

import './BreadcrumbTruncateUtilPopupContent.scss';

const differenceByElementId = differenceBy('elementId');

const BreadcrumbTruncateUtilPopupContent = ({
    isHovered,
    canDrop,
    breadcrumbPath,
    renderedBreadcrumbs,
    currentBoardId,
    dispatchClosePopup,
    connectDropTarget,
}) => {
    const prevIsHovered = usePrevious(isHovered);

    useEffect(() => {
        if (prevIsHovered && !isHovered) {
            setTimeout(() => {
                dispatchClosePopup();
            }, 1);
        }
    }, [isHovered, prevIsHovered]);

    const removedBreadcrumbs = differenceByElementId(breadcrumbPath, renderedBreadcrumbs).filter(
        ({ elementId }) => elementId !== currentBoardId,
    );

    return (
        <div ref={connectDropTarget} className="BreadcrumbTruncateUtilPopupContent">
            <ul>
                {removedBreadcrumbs.map(({ elementId, title, isRoot, color }) => (
                    <li key={elementId || 'root'}>
                        <Breadcrumb
                            elementId={elementId}
                            currentBoardId={currentBoardId}
                            title={title}
                            isRoot={isRoot}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

BreadcrumbTruncateUtilPopupContent.propTypes = {
    currentBoardId: PropTypes.string,
    canDrop: PropTypes.bool,
    isHovered: PropTypes.bool,
    breadcrumbPath: PropTypes.array,
    renderedBreadcrumbs: PropTypes.array,
    dispatchClosePopup: PropTypes.func,
    connectDropTarget: PropTypes.func,
};

export default breadcrumbTruncateUtilDropTarget(BreadcrumbTruncateUtilPopupContent);
